export type SpeechLanguage = 'zh-CN' | 'en-US' | 'ja-JP' | 'ko-KR'
export type SpeechAvailability = 'unchecked' | 'checking' | 'unsupported' | 'voices-unavailable' | 'voice-missing' | 'ready'
export function speechAvailabilityError(availability: SpeechAvailability): string {
  if (availability === 'unsupported') return 'speech-unavailable'
  if (availability === 'voices-unavailable' || availability === 'voice-missing') return availability
  return ''
}
export function isSpeechCompatibilityError(reason: string): boolean {
  return ['speech-unavailable', 'voices-unavailable', 'voices-loading', 'voice-missing', 'language-unavailable', 'voice-unavailable'].includes(reason)
}
export interface BuffSpeechPreferences {
  voices: Partial<Record<SpeechLanguage, string>>
  volume: number
  rate: number
}
